<template>
  <div class="confectionModal">
    <div class="confectionModal-top">
      <img
        class="confectionModal-image img-responsive"
        alt="envelope example"
        :src="image"
        width="400px"
      >
    </div>

    <div class="confectionModal-content">
        <h2 class="confectionModal-title">Ozdobna koperta na kupony</h2>
        <section class="confectionModal-descriptions">
          <p>
            Zapakowany prezent wzbudza więcej pozytywnych emocji i wywołuje radość u obdarowywanego.
            <br />
            Dedykowana koperta Pluxee to dodatek, który ułatwi przekazanie i przechowywanie kuponów.
          </p>
        </section>
      </div>
  </div>
</template>

<script>
export default {
  name: 'envelopeCouponModal',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
